import axios from "axios";
import NetworkUtils from "@/NetworkUtils";
import store from "../../store";
import GoldDropFirstTermCustomConfigConstance from "../constants/GoldDropFirstTermCustomConfigConstance";
const authorize = `Bearer ${store.getters.getToken}`;
const config = {
    headers: { Authorization: authorize }
};

export default {
    loadDefaultData(){
        return GoldDropFirstTermCustomConfigConstance;
    },

    loadData: async function () {
        let data = await axios.get(NetworkUtils.HOST + "/gold-drop-first-term-custom-config/load", config);
        let configRQ = {};
        if (data.data.length > 0) {
            configRQ = data.data[0].config;
        } else {
            configRQ = GoldDropFirstTermCustomConfigConstance;
        }
        // console.log('load maxFreqLine1k: '+ configRQ["maxFreqLine1k"]);
        if(!configRQ["maxFreqLine1k"]){
            configRQ.maxFreqLine1k = GoldDropFirstTermCustomConfigConstance.maxFreqLine1k;
            configRQ.maxFreqLine10k = GoldDropFirstTermCustomConfigConstance.maxFreqLine10k;
            // console.log('applied config', configRQ);
        }
        return configRQ;
    },

    async pushData(inputConfigData) {
        let config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: authorize
            },
        };
        let data = JSON.stringify(inputConfigData);
        //console.log('pushData ', data);
        await axios.post(NetworkUtils.HOST+"/gold-drop-first-term-custom-config/insertOrUpdate", data, config);
    },

}